import { doPostFetch } from "./apiFetchHelper";
const API_URL = `/api`;

export function pingSession() {
  return doPostFetch(`${API_URL}/ping`);
}

export function keepAliveSession() {
  return doPostFetch(`${API_URL}/ka`);
}

export function resetSession() {
  return doPostFetch(`${API_URL}/reset`);
}

export default {
  pingSession,
  keepAliveSession,
  resetSession,
};
